// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Services_fadeIn__31G7v","servicesListContent":"Services_servicesListContent__3hxkA","think":"Services_think__1fDYd","actions":"Services_actions__k4Zvz"};